import { debounce } from 'javascripts/utils/debounce';
import { toggleDisplay } from 'javascripts/utils/toggleDisplay';

const isElementFullyVisible = (element) => {
  const rect = element.getBoundingClientRect();
  return (
    rect.left >= 0 &&
    rect.right <= (window.innerWidth || document.documentElement.clientWidth)
  );
}

const scrollIntoView = (item) => {
  item.scrollIntoView({
    behavior: 'smooth',
    block: 'center',
    inline: 'center'
  });
}

const navAutoScroll = () => {
  for (const navContainer of document.querySelectorAll('.scroll-main-nav')) {
    const activeNavLink = navContainer.querySelector('.nav-link.active');
    if (!!activeNavLink && !isElementFullyVisible(activeNavLink)) {
      scrollIntoView(activeNavLink);
    }
  }
}


const firstNavLinkCallback = (items) => {
  const navLink = items[0];
  const navLeft = navLink.target.parentElement.previousSibling;

  toggleDisplay(navLink.intersectionRatio < 1, navLeft);
}

const lastNavLinkCallback = (items) => {
  const navLink = items[0];
  const navRight = navLink.target.parentElement.nextSibling;

  toggleDisplay(navLink.intersectionRatio < 1, navRight);
}

const observers = {}

const navButtonShowHide = () => {
  const navContainers = document.querySelectorAll('.scroll-main-nav');
  navContainers.forEach((navContainer, index) => {
    const options = { root: navContainer, rootMargin: '4px', threshold: [0, 1] };
    const firstNavLinkObserver = new IntersectionObserver(firstNavLinkCallback, options);
    firstNavLinkObserver.observe(navContainer.querySelector('.nav-link-first'));

    const lastNavLinkObserver = new IntersectionObserver(lastNavLinkCallback, options);
    lastNavLinkObserver.observe(navContainer.querySelector('.nav-link-last'));

    observers[index] = { firstNavLinkObserver, lastNavLinkObserver };
  });
}

window.addEventListener('load', function() {
  navAutoScroll();
  navButtonShowHide();
});

const debouncedOnStickHandler = debounce(() => {
  navAutoScroll();
}, 300);

window.addEventListener('gitb.topStick', debouncedOnStickHandler);
